"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTitle = exports.HeaderIcon = exports.HeaderRow = exports.HeaderContent = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "style__Container",
  componentId: "sc-1f0x4hz-0"
})(["display:flex;flex-direction:column;width:20%;background:", ";justify-content:center;padding:0.5rem 0;"], _colors["default"].blueGray.darken4);

exports.Container = Container;

var HeaderContent = _styledComponents["default"].div.withConfig({
  displayName: "style__HeaderContent",
  componentId: "sc-1f0x4hz-1"
})(["display:flex;width:100%;color:", ";justify-content:center;& > p{text-align:center;}"], _colors["default"].white.primary);

exports.HeaderContent = HeaderContent;

var HeaderRow = _styledComponents["default"].div.withConfig({
  displayName: "style__HeaderRow",
  componentId: "sc-1f0x4hz-2"
})(["display:flex;width:70%;margin:0 auto;justify-content:space-around;"]);

exports.HeaderRow = HeaderRow;

var HeaderIcon = _styledComponents["default"].div.withConfig({
  displayName: "style__HeaderIcon",
  componentId: "sc-1f0x4hz-3"
})(["width:40%;display:flex;justify-content:center;"]);

exports.HeaderIcon = HeaderIcon;

var HeaderTitle = _styledComponents["default"].div.withConfig({
  displayName: "style__HeaderTitle",
  componentId: "sc-1f0x4hz-4"
})(["text-align:center;display:flex;justify-content:center;width:40%;color:", ";"], _colors["default"].white.primary);

exports.HeaderTitle = HeaderTitle;